import React from 'react';
import { TextField } from '@mui/material';
import { styled } from '@mui/system';

// Create the styled DialogTextField component
const DialogTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent",
      boxShadow: "none",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#A8A8A8",
  },
  "& .MuiInputBase-root": {
    boxShadow:
      "0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A",
  },
}));

export default DialogTextField;
